module.exports = __webpack_public_path__ + "img/zhizao.ae1fd6fe.png";